import {BaseDtoModel} from './base-dto.model';

export class LoginResponseDtoModel extends BaseDtoModel {
  authToken: string;
}
